// extracted by mini-css-extract-plugin
export default {"join-btn":"Mission_join-btn__2fcSp","leave-btn":"Mission_leave-btn__ZEnHR"};